module.exports = __webpack_public_path__ + "static/media/icon-download-18-x-18.0c533a81.svg";